import React from 'react';
import NewPasswordForm from './components/NewPasswordForm/index';
import LoginFooter from '../login/components/LoginFooter';
import style from './NewPassword.module.scss';

const NewPassword = () => (
  <div className={style.loginPageBackground}>
    <div className={style.loginPageFormContainer}>
      <NewPasswordForm />
    </div>
    <div className={style.loginPageFooter}>
      <LoginFooter />
    </div>
  </div>
);

export default NewPassword;
